import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { getArticlesBySection, formatDate } from "@/lib/content";

export default function IndustryPreview() {
  const list = getArticlesBySection("industry");
  const mainList = list.slice(0, 6);
  const sideList = list.slice(0, 3);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 mt-14">
      <SectionHeading
        title="行业动态"
        subtitle="政策、市场与技术的深度观察"
        moreTo="/industry"
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-background-50 border border-background-200 rounded-lg p-6">
          <div className="flex items-center gap-2 text-sm text-foreground-500 mb-4">
            <i className="ri-line-chart-line text-accent-500" />
            最新动态一览（点击标题查看详情）
          </div>
          <ul className="divide-y divide-background-200">
            {mainList.map((item) => (
              <li key={item.id} className="py-4 first:pt-0 last:pb-0">
                <Link
                  to={`/detail/${item.id}`}
                  className="group flex items-start justify-between gap-4 cursor-pointer"
                >
                  <span className="flex items-start gap-3 min-w-0">
                    <i className="ri-article-line text-primary-500 mt-1 shrink-0" />
                    <span className="text-sm md:text-base text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2">
                      {item.title}
                    </span>
                  </span>
                  <span className="shrink-0 text-xs text-foreground-500 whitespace-nowrap flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {formatDate(item.date)}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="bg-primary-950 rounded-lg p-6 text-background-200">
          <h3 className="font-heading font-semibold text-lg text-background-50 flex items-center gap-2 mb-4">
            <i className="ri-bookmark-3-line text-accent-400" />
            推荐专题
          </h3>
          <div className="flex flex-col gap-4">
            {sideList.map((item) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="group flex gap-3 cursor-pointer"
              >
                <span className="w-16 h-16 shrink-0 rounded-md overflow-hidden bg-primary-900">
                  <img
                    src={item.cover}
                    alt={`${item.title}配图`}
                    title={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </span>
                <span className="min-w-0">
                  <span className="block text-sm text-background-100 group-hover:text-accent-400 transition-colors line-clamp-2">
                    {item.title}
                  </span>
                  <span className="block text-xs text-background-400 mt-1">
                    {formatDate(item.date)}
                  </span>
                </span>
              </Link>
            ))}
          </div>
          <Link
            to="/industry"
            className="mt-6 inline-flex items-center gap-1 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
          >
            浏览全部行业动态
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}